import type React from 'react';
import {
  Activity,
  BarChart3,
  Building2,
  Cloud,
  Code2,
  Cpu,
  Factory,
  Globe,
  Home,
  Hotel,
  Key,
  Layers,
  Lightbulb,
  LineChart,
  Lock,
  RefreshCw,
  Server,
  Settings,
  Shield,
  Smartphone,
  Wifi,
  Zap,
} from 'lucide-react';
import type { ProductIconName } from './types';

export const PRODUCT_ICON_MAP: Record<
  ProductIconName,
  React.ComponentType<{ size?: number; strokeWidth?: number; className?: string; 'aria-hidden'?: boolean }>
> = {
  cloud: Cloud,
  activity: Activity,
  globe: Globe,
  shield: Shield,
  cpu: Cpu,
  smartphone: Smartphone,
  code: Code2,
  lock: Lock,
  layers: Layers,
  'bar-chart': BarChart3,
  wifi: Wifi,
  refresh: RefreshCw,
  zap: Zap,
  server: Server,
  key: Key,
  chart: LineChart,
  home: Home,
  hotel: Hotel,
  building: Building2,
  factory: Factory,
  lightbulb: Lightbulb,
  settings: Settings,
};
